import { WhatsNewModal } from './WhatsNewModal';
import upgradeImage from './offer-display-upgrade.png';

type OfferDisplayUpgradeModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const OfferDisplayUpgradeModal = (p: OfferDisplayUpgradeModalProps) => (
  <WhatsNewModal
    {...p}
    tag="New functionality here!"
    title="Offer Display section upgrade"
    description="Turn workout preview on and select workouts to promote on Offer Display section."
    imageSrc={upgradeImage}
  />
);
